import { BrowserRouter, Route, Routes } from "react-router-dom";
import Home from "./paginas/principal/home";
import Login from "./paginas/principal/login";
import CadEmpresa from "./paginas/cadastro/empresa";
import CadFuncionario from "./paginas/cadastro/funcionario";
import CadUsuario from "./paginas/cadastro/usuario";
import CadGrupoProduto from "./paginas/cadastro/grupoproduto";
import CadProduto from "./paginas/cadastro/produto";
import CadCliente from "./paginas/cadastro/cliente";
import CadFornecedor from "./paginas/cadastro/fornecedor";
import CadConta from "./paginas/cadastro/conta";
import CadMoeda from "./paginas/cadastro/moeda";
import CadBanco from "./paginas/cadastro/banco";
import CadKit from "./paginas/cadastro/kit";
import CadEquipe from "./paginas/cadastro/equipe";
import Footer from "./componente/footer";
import RelCliente from "./paginas/relatorio/cliente";
import Manutencao from "./paginas/operacoes/manutencao";
import LancTitulo from "./paginas/operacoes/lanctitulo";
import LancFolha from "./paginas/operacoes/lancfolha";
import LancDespesa from "./paginas/operacoes/lancdespesa";
import LancViagem from "./paginas/operacoes/viagem";
import GerarFicha from "./paginas/operacoes/ficha";
import Caixa from "./paginas/operacoes/caixa";
import RelFichaVinculada from "./paginas/relatorio/fichavinculada";
import RelFichaCobrar from "./paginas/relatorio/fichacobrar";
import RelFichaCobradas from "./paginas/relatorio/fichacobradas";
import RelVendaPorVendedor from "./paginas/relatorio/vendaporvendedor";
import RelVendaPorEquipe from "./paginas/relatorio/vendaporequipe";
import RelVendaEmAberto from "./paginas/relatorio/vendaemaberto";
import PrivateRoute from "./componente/PrivateRoute"; // novo componente

function App() {
  return (
    <>      
      <BrowserRouter>      
      <Routes>
        <Route path="/" element={<Login />}/>
        <Route path="/home" element={<PrivateRoute><Home /></PrivateRoute> } />
        
        <Route path="/cadastro/empresa" element={<PrivateRoute><CadEmpresa /></PrivateRoute>} />
        <Route path="/cadastro/funcionario" element={<PrivateRoute><CadFuncionario /></PrivateRoute>} />
        <Route path="/cadastro/usuario" element={<PrivateRoute><CadUsuario /></PrivateRoute>} />
        <Route path="/cadastro/grupoproduto" element={<PrivateRoute><CadGrupoProduto /></PrivateRoute>} />
        <Route path="/cadastro/produto" element={<PrivateRoute><CadProduto /></PrivateRoute>} />
        <Route path="/cadastro/kit" element={<PrivateRoute><CadKit /></PrivateRoute>} />
        <Route path="/cadastro/equipe" element={<PrivateRoute><CadEquipe /></PrivateRoute>} />
        <Route path="/cadastro/cliente" element={<PrivateRoute><CadCliente /></PrivateRoute>} />
        <Route path="/cadastro/fornecedor" element={<PrivateRoute><CadFornecedor /></PrivateRoute>} />
        <Route path="/cadastro/categoriafinanceira" element={<PrivateRoute><CadConta /></PrivateRoute>} />
        <Route path="/cadastro/condicoespagamento" element={<PrivateRoute><CadMoeda /></PrivateRoute>} />
        <Route path="/cadastro/caixabanco" element={<PrivateRoute><CadBanco /></PrivateRoute>} />

        <Route path="/operacoes/manutencao" element={<PrivateRoute><Manutencao /></PrivateRoute>} />
        <Route path="/operacoes/lanctitulo" element={<PrivateRoute><LancTitulo /></PrivateRoute>} />
        <Route path="/operacoes/lancdespesa" element={<PrivateRoute><LancDespesa /></PrivateRoute>} />
        <Route path="/operacoes/lancfolhapagamento" element={<PrivateRoute><LancFolha /></PrivateRoute>} />
        <Route path="/operacoes/viagem" element={<PrivateRoute><LancViagem /></PrivateRoute>} />
        <Route path="/operacoes/gerarficha" element={<PrivateRoute><GerarFicha /></PrivateRoute>} />
        <Route path="/operacoes/caixa" element={<PrivateRoute><Caixa /></PrivateRoute>} />

        <Route path="/relatorio/cliente" element={<PrivateRoute><RelCliente /></PrivateRoute>} />
        <Route path="/relatorio/fichavinculada" element={<PrivateRoute><RelFichaVinculada /></PrivateRoute>} />
        <Route path="/relatorio/fichacobrar" element={<PrivateRoute><RelFichaCobrar /></PrivateRoute>} />
        <Route path="/relatorio/fichacobradas" element={<PrivateRoute><RelFichaCobradas /></PrivateRoute>} />
        <Route path="/relatorio/vendaporvendedor" element={<PrivateRoute><RelVendaPorVendedor /></PrivateRoute>} />
        <Route path="/relatorio/vendaporequipe" element={<PrivateRoute><RelVendaPorEquipe /></PrivateRoute>} />
        <Route path="/relatorio/vendaemaberto" element={<PrivateRoute><RelVendaEmAberto /></PrivateRoute>} />
      </Routes>      
      </BrowserRouter>
      <Footer />
    </>
  );
}

export default App;
